module.exports = __webpack_public_path__ + "static/media/earth.73d822de.svg";